import getColor from '~/lib/getColor'

export const BORDER = `1px solid ${getColor('blackAlpha15')}`
export const NOTES_TO_CUSTOMER_MODAL = 'im-notes-to-customer-modal'
export const NOTES_TO_CUSTOMER = 'im-notes-to-customer'
export const MAX_CHARACTER_LENGTH_NOTE = 2000
export const RELEASE_QUOTE_DFM = 'release-quote-dfm'
export const RELEASE_DFM = 'release-dfm'
export const RELEASE_QUOTE = 'release-quote'
export const PLACEMENT = 'dfm-report'
export const DEFAULT_MAX_LENGTH = 35
export const SPACING = '6px'
export const SALES_REP_CONTACT_INFO = 'im-sales-rep-contact-info'
export const SALES_REP_CONTACT_INFO_MODAL = 'im-sales-rep-contact-info-modal'
export const REMOVE_SALES_REP_CONTACT_INFO_MODAL =
    'im-remove-sales-rep-contact-info-modal'
export const RELEASE_DFM_CONFIRMATION = 'release-dfm-confirmation'
export const RELEASE_DFM_TITLE = 'Are you sure you want to release DFM?'
export const RELEASE_DFM_DESCRIPTION =
    'No pricing information will be released to the customer. If you want to release pricing, please cancel and press "Release quote"'
export const RELEASE_QUOTE_TITLE = 'Are you sure you want to release the quote?'
export const RELEASE_QUOTE_DESCRIPTION =
    'All provided pricing and DFM reports will be made available to the customer and customer will receive an email notification.'
export const ODP_RELEASE_DFM_DESCRIPTION =
    'You are releasing the DFM reports attached to the parts in this order. The customer will receive an email notification.'
export const EMAIL_SUBJECT_PLACEHOLDER =
    'E.g. Comments on project requirements, pricing, additional quantity or lead time options'
export const TO = 'to'
export const CC = 'cc'
export const FROM = 'from'
export const SUBJECT = 'subject'
export const NOTES = 'notes'
export const REQUIRED_FIELDS = [TO, SUBJECT]
export const ON_HOLD_PROPERTY = 'on-hold'
export const QUOTE_WITH_MOLD_TOOL_REVISION = 'QUOTE_WITH_MOLD_TOOL_REVISION'
export const QUOTE_DELETED = 'Deleted'
export const DELETED_QUOTE_SELECTED_QMR = 'deleted'
